import * as Styled from '../../policy.styled';

export default function UseRestrictionPolicyKo() {
  return (
    <Styled.MainWrapper style={{ marginTop: 40 }}>
      <h3 style={{ marginBottom: '40px' }}>서비스 운영정책</h3>
      본 운영정책은 주식회사 버블탭(이하 “회사”)가 제공하는 ‘팅글’, ‘리워드’, 등 서비스(이하 ‘서비스’)를 운영하면서,
      서비스 내에 발생할 수 있는 문제 상황 및 서비스와 관련된 콘텐츠(이용약관 제2조 2항 참조) 관리에 대하여 일관성있게
      대처하기 위해 서비스 운영의 기준과 이용자 여러분이 지켜주셔야 할 세부적인 사항이 규정되어 있습니다. 운영정책을
      지키지 않을 경우, 위반 횟수 또는 위반의 경중에 따라 회사가 제공하는 서비스 일체에서 불이익을 당할 수 있으니 주의
      깊게 읽어 주시기기 바랍니다. 또한 본 운영정책에서 사용하는 용어의 뜻은 이용약관의 그것과 동일합니다.
      <br />
      <br />
      회사는 서비스와 관련된 정책을 개선하고자 회원과의 지속적인 의견교환을 통해 합리적인 운영정책을 세울 수 있도록
      노력하고 있으며, 그러한 경우 최소 7일 전에 서비스 공지사항을 통해 공지하도록 하겠습니다.
      <p>제1조 회원의 권리와 의무</p>
      <ol>
        ① 회원의 권리 <br />
        회원은 온라인 고객센터 등을 통해 서비스에 대한 각종 문의를 하실 수 있습니다.
        <br />
        <br />② 회원의 의무
        <ol>
          <li>
            회원은 서비스 내에서 법령, 이용약관, 운영정책 등에 위배되는 행동 및 다른 회원의 서비스 이용에 방해가 되는
            활동을 하지 않습니다. 이러한 의무를 위반하는 경우, 회사 내부 규정에 따라 별도 안내 없이 서비스 이용제한
            조치가 이루어질 수 있습니다.
          </li>
          <li>
            회원은 이용약관, 운영정책 등 규정 및 회사 홈페이지 공지사항 등을 수시로 확인하여야 하며, 이를 확인하지 않아
            발생하는 사항에 대해서는 회사의 도움을 받기 어려울 수 있습니다.
          </li>
          <li>
            이용자는 회사와 기타 제3자의 저작권 등 지적재산권 침해, 명예 손상, 업무를 방해하는 행위, 기타 관련 법령 위반
            사항이 발견되는 경우 서비스 이용에 제한을 받을 수 있으며 관계 법령에 따라 민형사상의 책임이 발생할 수
            있습니다.
          </li>
        </ol>
      </ol>
      <p>제2조 서비스 이용 제한 조치</p>
      회사의 서비스 이용자가 제3조에 해당하는 운영 정책에 위반되는 활동을 할 경우, 사유 해당 횟수 또는 회사가 결정하는
      위반의 경중에 따라 다음의 단계로 이용제한 조치가 취해집니다. 제한 조치는 순차적으로 적용될 필요가 없으며 회사의
      내부 정책에 따라 결정됩니다. 다만 행동의 경중에 따라 단계별이 아닌, 즉시 고단계의 조치가 취해질 수 있습니다.
      <br />
      <br />
      <ol>
        ① 서비스 이용 관련 단계별 조치
        <li>1단계: 정책 안내 및 해당 내용 비공개 또는 삭제 처리</li>
        <li>2단계: 해당 내용 비공개 또는 삭제 처리 후 회사가 운영하는 각 커뮤니티/SNS 기능 최대 7일 간 금지</li>
        <li>3단계: 해당 내용 비공개 또는 삭제 처리 후 계정 사용 최대 7일 간 금지</li>
        <li>4단계: 해당 내용 비공개 또는 삭제 처리 후 계정 사용 최대 30일 간 금지</li>
        <li>5단계: 해당 내용 비공개 또는 삭제 처리 후 계정 사용 영구 금지</li>
      </ol>
      <ol>
        ② 창작물, AI 캐릭터, AI 서사, AI 테마, 등 (이하 AI 애셋) 게시 관련 단계별 조치
        <li>1단계: 정책 안내 및 해당 창작물 또는 AI 애셋 비공개 또는 삭제 처리</li>
        <li>2단계: 해당 창작물 또는 AI 애셋 비공개 또는 삭제 처리 후 콘텐츠 생성 및 소비 도구 기능 최대 7일 간 금지</li>
        <li>3단계: 해당 창작물 또는 AI 애셋 비공개 또는 삭제 처리 후 계정 사용 최대 7일 간 금지</li>
        <li>4단계: 해당 창작물 또는 AI 애셋 비공개 또는 삭제 처리 후 계정 사용 최대 30일 간 금지</li>
        <li>5단계: 해당 창작물 또는 AI 애셋 비공개 또는 삭제 처리 후 계정 사용 영구 금지</li>
      </ol>
      <ol>
        ③ 이의 제기
        <li>이용자는 이러한 이용 제한 조치에 이의를 제기할 수 있는 소명 기간을 가질 수 있습니다. </li>
        <li>1단계와 5단계는 30일 간의 소명 기간을 거치며, 2~4단계는 제재 기간 내 소명할 수있습니다.</li>
        <li>
          회사는 이러한 이의가 접수된 날로부터 영업일 3~5일 이내 이를 검토하고 적합한 사유일 경우 즉시 복구 처리합니다.
        </li>
        <li>
          단 이의제기 시, 회사에 지속적으로 욕설, 음담패설, 협박 및 기타 회사의 정상적인 업무를 방해하는 등의 행위를
          하는 경우, 회사는 이의제기 사항에 대한 심리 등 후속 절차를 진행하지 않을 수 있습니다.
        </li>
      </ol>
      <p>제3조 이용 제한 활동</p>
      이용자는 다음과 같은 활동을 할 경우, 제2조의 이용 제한 조치 사유에 해당하게 됩니다.
      <br />
      <br />
      <ol>
        ① 서비스 이용 관련 제한 활동
        <li>
          개인 정보 침해
          <ol>
            <li>타인의 정보를 노출하는 행위</li>
            <li>다른 회원의 계정을 부정하게 사용하는 행위</li>
            <li>계정을 타인에게 양도하거나 타인과 공유하는 등 계정을 부정 사용했다고 합리적으로 의심되는 행위</li>
            <li>다른 회원에 대한 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위</li>
          </ol>
        </li>
        <li>
          해킹
          <ol>
            <li>휴대폰 해킹 등을 통해 UUID를 변조하여 서비스를 이용하는 행위</li>
            <li>회사로부터 특별한 권한을 부여받지 않고 회사의 클라이언트 프로그램을 변경하거나 서버를 해킹하는 행위</li>
            <li>
              회사가 미처 파악하지 못하였거나 수정하지 않은 서비스의 취약점을 이용하여 서비스를 이용하거나 비공개 자료를
              열람하여 정보를 위조, 변조하는 행위
            </li>
            <li>
              자동 접속 프로그램 등을 사용하는 등 정상적인 용법과 다른 방법으로 서비스를 이용하여 회사의 서버에 부하를
              일으켜 회사의 정상적인 서비스를 방해하는 행위
            </li>
          </ol>
        </li>
        <li>
          불법 영리 활동
          <ol>
            <li>불법, 사행성 사이트 홍보</li>
            <li>불법 제품을 판매하거나 홍보</li>
            <li>회사로부터 동의를 받지 않았거나 회사 세부이용지침 등에서 불허한 영리활동을 하는 행위</li>
            <li>
              서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 광고성 정보 또는
              스팸메일(Spam Mail)을 전송하는 행위
            </li>
            <li>범죄와 결부된다고 객관적으로 판단되는 행위</li>
            <li>기타 관계 법령에 위배 또는 불법적이거나 부당한 행위</li>
          </ol>
        </li>
        <li>
          저작권 침해
          <ol>
            <li>
              회사 및 타 회원 또는 기타 제3자의 특허, 상표, 영업비밀, 저작권, 기타 지적재산권을 침해하는 내용을 게시 및
              사용하거나 또는 기타의 방법으로 제3자에게 유포하는 행위
            </li>
            <li>
              회사 서비스를 이용하여 얻은 정보를 적법한 권한 또는 회사의 승낙 없이 복제 또는 유통시키거나 영리적으로
              사용하는 행위
            </li>
            <li>타인의 저작물을 불법적인 경로로 획득할 수 있는 정보나 방법을 제공하는 행위</li>
            <li>방송, 음원, 영화, 만화 등 타인의 저작물을 당사자의 동의 없이 공유</li>
            <li>타인의 권리에 속하는 상표권, 의장권 등을 무단으로 침해</li>
            <li>저작권자로부터 권리침해 신고가 접수된 저작물에 대한 침해 행위</li>
            <li>위 행위 외 저작권 침해 행위에 해당될 경우</li>
          </ol>
        </li>
        <li>
          서비스 이용 방해
          <ol>
            <li>
              수치심이나 혐오감, 공포심을 불러일으키는 비속어나 욕설 또는 도배글, 스토킹 등 다른 회원의 서비스 이용을
              방해하는 행위
            </li>
            <li>
              검색 유입을 목적으로 사람의 힘으로 하기 힘들다고 보여지는 과도한 글을 업로드 하여 악의적인 목적이라고
              판단되는 행위
            </li>
            <li>출처가 불분명한 게시물을 게재하거나 유언비어를 유포하는 경우</li>
          </ol>
        </li>
        <li>
          음란물 유포
          <ol>
            <li>음란사이트를 연결(링크)하는 행위</li>
            <li>성매매 관련 정보를 공유하는 행위</li>
          </ol>
        </li>
        <li>
          차별 및 갈등 조장
          <ol>
            <li>
              성별, 종교, 장애, 연령, 사회적 신분, 인종, 지역, 직업 등을 차별하거나 편견을 조장하는 활동을 할 경우
            </li>
            <li>정치적 선동을 하거나 유도하는 행동을 할 경우</li>
            <li>위 항목 외 차별과 갈등을 조장하는 행위를 할 경우</li>
          </ol>
        </li>
        <li>
          게시물 게시
          <ol>
            <li>게시물 작성 및 변경 시 허위내용을 등록하는 행위</li>
            <li>비정상 또는 불법 프로그램의 배포 및 이용 방법이 포함된 내용을 작성한 경우</li>
            <li>사전에 승인되지 않은 타인의 저작물을 이용하여 글을 작성한 경우</li>
            <li>타인의 저작물을 불법적인 경로로 획득할 수 있는 정보나 방법에 대한 내용을 작성한 경우</li>
            <li>같은 내용의 글을 반복적으로 등록하여, 타인의 서비스 이용을 방해하는 경우</li>
            <li>음란물을 게재하거나 성매매 관련 정보 글을 작성한 경우</li>
            <li>타인에게 비하 또는 비난, 욕설 등의 행위를 할 경우</li>
            <li>
              성별, 종교, 장애, 연령, 사회적 신분, 인종, 지역, 직업 등을 차별하거나 편견을 조장하는 내용을 작성할 경우
            </li>
            <li>정치적 선동을 하거나 유도하는 내용을 게시한 경우</li>
            <li>위 항목 외 타인의 서비스 이용을 방해하거나 불법적인 내용이 담긴 글을 작성할 경우</li>
          </ol>
        </li>
        <li>
          기타
          <ol>
            <li>회사 또는 관계자를 사칭하는 행위</li>
            <li>회사 및 기타 제3자의 명예를 손상시키거나 불이익을 주는 행위</li>
            <li>회사가 게시한 정보를 변경하는 행위</li>
            <li>
              닉네임, 게시물, 댓글 상 회사, 타 업체 또는 저작권자와 관련된 사항을 사칭하는 등 서비스의 적정한 이용 외의
              다른 목적으로 서비스를 악용할 의도가 있다고 판단되는 행위를 할 경우
            </li>
            <li>더 이상 서비스를 사용할 의사가 없음을 표명하고 재가입 제한에 동의한 후 서비스를 탈퇴한 경우</li>
            <li>위 항목 외 서비스에서 금지하는 활동을 한 경우</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② 창작물 및 AI 애셋 게시 관련 제한 활동
        <li>
          성인물
          <ol>
            <li>성인물 표시 없이 성인물 콘텐츠를 발행하는 경우</li>
            <li>성인물에 해당하는 콘텐츠를 성인물의 연령 등급을 임의로 변경하는 경우</li>
            <li>
              정보통신에 관한 심의 규정에서 정의한 유통 불가 묘사 및 사회 통념상 용인되기 어려운 행위를 집중적으로
              묘사한 경우
            </li>
            <li>
              성기 등 성적 부위나 행위를 별도의 모자이크(윤곽을 파악할 수 없는 수준 이상) 없이 적나라하게 묘사한 경우
            </li>
            <li>기타 관계 법령 위반으로 긴급한 조치가 필요하다고 판단되는 경우</li>
          </ol>
        </li>
        <li>
          아동 학대
          <ol>
            <li>
              아동·청소년의 성보호에 관한 법률상 사회통념에 비추어 아동·청소년(19세 미만)이 등장하여 성적 행위를 하는
              내용을 표현한 경우
            </li>
            <li>
              아동·청소년으로 명백하게 인식될 수 있는 사람이나 표현물이 등장하여 성적 행위를 하는 내용을 표현한 경우
            </li>
          </ol>
        </li>
        <li>
          폭력
          <ol>
            <li>
              자해, 자살과 같은 심각한 부상이나 죽음으로 이어질 수 있는 행위, 그 밖에 정신적·신체적 학대를 미화하거나
              조장하는 것
            </li>
            <li>
              약물 및 무기 사용 등 범죄를 미화하거나 폭탄 또는 무기 제조와 같은 범죄 방법을 사실적으로 묘사하여 범죄를
              조장하는 것
            </li>
            <li>
              유괴, 인신매매, 살인, 상해, 고문, 신체 손괴, 장기 밀매 등 잔인하고 폭력적인 장면을 구체적으로 묘사하거나
              조장하는 것
            </li>
            <li>
              존속·비속, 노인, 임산부, 장애인, 아동, 사회적 약자에 대한 협박·상해·폭행·살인 등을 구체적으로 묘사하거나
              미화하여 전통적인 윤리를 훼손할 우려가 있는 것
            </li>
            <li>실제 범죄나 사건에 대한 피해자 모욕 및 혐오를 조장하는 것</li>
            <li>동물에 대한 살상, 학대, 사체 등을 구체적으로 표현하여 잔혹감 또는 혐오감을 주는 내용</li>
          </ol>
        </li>
        <li>
          혐오적 표현
          <ol>
            <li>
              인종, 민족, 종교, 장애, 연령, 국적, 성적 지향, 성별, 성적 정체성, 규범이나 사회 구조의 체계 등을 문제 삼아
              개인이나 집단에 대한 폭력 또는 증오심을 조장하는 경우
            </li>
            <li>기타 다른 이용자에게 혐오감 및 불쾌감을 일으키는 표현을 사용한 경우</li>
            <li>기타 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적의 묘사</li>
          </ol>
        </li>
        <li>
          불법적 행위 유도 및 묘사
          <ol>
            <li>성매매·음란 정보를 제공한 경우</li>
            <li>도박 정보 제공한 경우</li>
            <li>불법 식·의약품 정보 제공한 경우</li>
            <li>해킹 소프트웨어 또는 소스코드 정보한 경우</li>
            <li>범죄를 교사·방조하거나 선전·선동할 우려가 현저한 것</li>
            <li>서비스 관계자 또는 서비스를 사칭하거나 그 오해의 소지를 줄 수 있는 것</li>
            <li>그 밖에 위법 행위의 계획 또는 실행을 구체적으로 묘사한 것</li>
            <li>기타 법령(불법 금융, 개인정보 거래 등) 위반 정보 제공한 경우</li>
          </ol>
        </li>
        <li>
          광고
          <ol>
            <li>
              표시광고법상 광고성 콘텐츠는 소비자들이 그 사실을 쉽게 알 수 있도록 경제적 이해관계를 명확히 표시하는
              문구를 삽입하지 않은 경우
            </li>
            <li>불법, 사행성 사이트를 직접 또는 간접적으로 홍보하는 경우</li>
            <li>불법 제품 판매를 직접적 또는 간접적으로 홍보하는 경우</li>
          </ol>
        </li>
        <li>
          저작권
          <ol>
            <li>본인의 창작물이 아닌 경우</li>
            <li>저작물을 원저작자의 허락을 받지 않고 사용한 경우</li>
            <li>원작과 원작자가 명백한 저작물의 일부 또는 전체를 무단으로 사용한 경우</li>
            <li>
              원작 및 원작자가 널리 알려져 있으며 적법한 유통 경로가 명확한 창작물 전체의 무단 전재·배포 등 저작권
              침해가 명백히 인지되는 경우
            </li>
          </ol>
        </li>
        <li>
          콘텐츠 형식
          <ol>
            <li>인위적으로 콘텐츠와 관련된 정량적 수치(예를 들면, 챗수, 좋아요 수, 등)를 조작하는 경우</li>
            <li>
              정상적인 콘텐츠가 아닌 경우(예를 들면, 콘텐츠의 내용이 없거나, 서비스의 본래 취지와 부합하지 않는 콘텐츠)
            </li>
            <li>기타 콘텐츠 내용이 서비스 게재에 부적합하다고 판단되는 경우</li>
          </ol>
        </li>
        <li>
          기타
          <ol>
            <li>회사, 다른 회원 또는 제3자를 비방하거나 모함하여 명예를 손상시키는 경우</li>
            <li>공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등의 유포에 해당하는 경우</li>
            <li>
              간행물윤리위원회(현 출판문화산업진흥원) 및 한국방송통신심의위원회에서 규정하고 있는 유해간행물의
              심의기준에 위반되는 경우
            </li>
            <li>범죄적 행위에 결부된다고 인정되는 내용인 경우</li>
            <li>회사 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우</li>
            <li>승인되지 않은 광고, 판촉물을 게재하는 경우</li>
            <li>출처가 불분명한 게시물을 게재하거나 유언비어를 유포하는 경우</li>
          </ol>
        </li>
      </ol>
      <p>제4조 서비스 이용상 신고제도 운영</p>
      ① 회원은 관련 법령, 서비스 이용약관, 본 운영정책 등에 위배되는 게시물을 확인한 경우 언제라도 회사에 신고하는 등의
      조치를 취할 수 있습니다.
      <br />
      <br />
      ② 신고할 때는, 신고하려는 대상의 출처(URL 등)와 사유를 함께 제출해야 합니다. 이러한 출처와 사유는 회사 담당자에게
      전달되고, 담당자는 이를 바탕으로 제한 여부를 신중히 검토합니다.
      <br />
      <br />
      ③ 신고자의 생각과 달리 해당 신고 대상이 명백히 관련 법령, 서비스 이용약관, 본 운영정책 등을 위반한다고 판단되지
      않을 경우에는 조치가 이루어지지 않을 수 있습니다.
      <br />
      <br />
      ④ 이미 신고 사항에 대한 판단이 이루어진 사안이라도, 추후 법원의 판결이나 권한 있는 행정 기관의 처분 등이 있게 되어
      이전 판단에 문제가 있었음이 드러날 경우, 회사의 기존 판단이 변경될 수 있습니다.
      <br />
      <br />⑤ 신고 내용을 검토하는 과정에서 해당 대상에 대한 조치 여부 뿐 아니라 추가로 해당 회원 계정에 대한 이용제한도
      이루어질 수 있습니다. 이러할 경우 해당 회원의 서비스 이용이력, 운영정책 등 위반이력 및 그 경중, 관련법령, 서비스
      이용약관, 본 운영정책 등을 종합적으로 고려하여 결정합니다.
      <p>제5조 서비스 휴면 정책(장기 미접속 회원에 대한 조치)</p>
      ① 1년동안 로그인하지 않으면 개인정보 분리보관
      <br />
      <br />② 개인정보 분리보관 이후 4년 동안 로그인하지 않으면 개인정보 파기 및 이용계약 해지
      <br />
      <p>제6조 환불 어뷰징 금지</p>
      ① 환불 어뷰징: 이용자가 회사의 디지털 상품이나 서비스를 회사의 내부 재화(이용약관 제2조 1항 참조)로 구매하고 이를
      소비한 후 Google Play Console, Apple App Store, 또는 그 이외의 기관을 통해 소비한 포인트 재화에 대한 환불을
      요청하는 환불 남용 및 디지털 절도는 사기성 부정 행위 및 절도로 간주됩니다. 회사는 이러한 행위를 이용약관 및
      운영정책 위반으로 간주합니다.
      <br />
      <br />
      ② 환불 어뷰징 사례에 대한 회사의 결정은 최종적입니다. 이용자는 이에 대해 이의를 제기하거나 이의를 제기할 권리를
      포기하고 회사의 결정에 따르는 데 동의합니다.
      <br />
      <br />③ 환불 어뷰징에 연루된 이용자는 다음과 같이 처리됩니다.
      <ol>
        <li>
          법적 조치: 회사는 환불 어뷰징에 연루된 것으로 확인된 모든 이용자에 대해 법적 조치를 취할 권리를 보유합니다.
          회사는 관련 법령에 따라 환불 어뷰징으로 인해 회사가 입은 손실을 회복하기 위한 민사 소송을 제기할 것입니다.
        </li>
        <li>
          영구 금지: 환불 어뷰징에 연루된 이용자는 회사 플랫폼에서 영구적으로 금지됩니다. 이 금지 조치는 관련 이용자의
          모든 계정과 장치에 적용되며, 해당 이용자는 무기한 회사 서비스 이용이 금지됩니다.
        </li>
      </ol>
      ④ 무관용 (zero-tolerance policy) 정책: 회사는 환불 어뷰징 대해 무관용 정책을 유지하고 있습니다. 회사는 플랫폼의
      무결성 보호, 이용자들에게 효과적인 서비스 제공, 및 콘텐츠 크리에이터의 권리를 보호하며 모든 이용자에게 공정하고
      투명한 경험을 보장하기 위해 최선을 다하고 있습니다.
      <br />
      <br />⑤ 사용자의 의무: 회사 플랫폼의 서비스를 이용함으로써 이용자는 다음 사항에 동의하게 됩니다.
      <ol>
        <li>모든 형태의 환불 어뷰징 행위를 하지 않습니다.</li>
        <li>이용약관 및 운영정책을 항상 준수합니다.</li>
        <li>환불 어뷰징이 의심되는 사례를 발견하면 즉시 당사에 신고합니다.</li>
      </ol>
    </Styled.MainWrapper>
  );
}
